import React, {useState} from 'react';

import {Button} from '@pb/kit-component-button';
import {Dialog, DialogFooter, DialogHeader, DialogMain} from '@pb/kit-component-dialog-v2';
import {Group} from '@pb/kit-component-group';

type Props = {
    caption: string,
    text: string | undefined,
};

export const DetailedMessage = ({caption, text}: Props) => {
    const [show, setShow] = useState(false);

    const onClose = () => setShow(false);
    const onClick = () => setShow(true);

    return (
        <>
            <Button disabled={!text} variant="Type.SECONDARY" onClick={onClick}>{caption}</Button>
            <Dialog shown={show} setShown={setShow}>
                <Group direction="v" style={{maxWidth: 900}}>
                    <DialogHeader onClose={onClose}>{caption}</DialogHeader>
                    <DialogMain style={{maxHeight: 600}}>
                        <Group justify="center" className="pdx-l">
                            {text}
                        </Group>
                    </DialogMain>
                    <DialogFooter>
                        <Group justify="end" style={{width: '100%'}}>
                            <Button variant="Type.SECONDARY" onClick={onClose}>Close</Button>
                        </Group>
                    </DialogFooter>
                </Group>
            </Dialog>
        </>
    );
};
